<template>
  <div class="thirdMall" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <!-- <van-nav-bar title="销巴生活" left-arrow @click-left="onClickLeft" /> -->
    <div class="main">
      <div class="goodsImg" :style="goodsImgHeight">
        <img :src="detail.goods_img" alt="" />
      </div>
      <h2 class="goodsTitle">
        <span v-if="detail.goods_type == 1">淘宝</span>
        <span v-if="detail.goods_type == 2">天猫</span>
        <span v-if="detail.goods_type == 3">京东</span>
        {{ detail.goods_title }}
      </h2>
      <div class="goodsMsg">
        <div class="goodsMoney">
          <strong><i>￥</i>{{ goodsMoney }}</strong>
          <s>￥{{ goodsOriginalMoney }}</s>
        </div>
        <div class="coupon" v-if="couponAmount != 0">
          <strong>{{
            couponAmount.indexOf("null") > -1 ? "0" : couponAmount
          }}</strong>
          <span>元优惠券</span>
        </div>
      </div>
      <div v-if="shortName == 'JD'">
        <button class="copyBtn" @click="toJD()">点击跳转至商品详情页</button>
      </div>
      <div v-else>
        <button class="copyBtn" @click="copy()">点击复制淘口令</button>
        <p ref="copytxt" style="position: fixed; top: -100px; opacity: 0">
          {{ tpwd }}
        </p>
        <p class="copyExplain">复制淘口令后，进入淘宝购买商品</p>
      </div>
      <div class="downloadBtn" @click="register()">
        <strong>点击下载销巴生活APP</strong>
        <p>下载销巴生活APP，更多优惠等着你</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodsImgHeight: {
        height: document.body.clientWidth - 40 + "px",
      },
      isiOSX: false,
      detail: {},
      goodsMoney: "",
      goodsOriginalMoney: "",
      couponAmount: "",
      mobile: "",
      shareCode: "",
      shortName: "",
      goodsId: "",
      memberId: "",
      tpwd: "",
    };
  },
  methods: {
    //返回
    onClickLeft() {
      this.params("", "", "goBack");
    },
    //跳转jd
    toJD() {
      this.$api
        .post("third-mall/index/getTaoWord", {
          short_name: this.shortName,
          goods_id: this.detail.item_url,
          member_id: this.memberId,
          coupon_url: this.detail.coupon_url,
        })
        .then((res) => {
          window.location.href = res.longTpwd;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //注册
    register() {
      this.$router.push({
        path: "/share",
        query: {
          shareCode: this.shareCode,
          mobile: this.mobile,
        },
      });
    },
    //获取详情
    getDetail() {
      this.$api
        .post("/third-mall/index/qCode/Detail", {
          short_name: this.shortName,
          goods_id: this.goodsId,
        })
        .then((res) => {
          this.detail = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    //复制
    copy() {
      const debtor_range = document.createRange();
      debtor_range.selectNode(this.$refs.copytxt);
      const debtor_selection = window.getSelection();
      if (debtor_selection.rangeCount > 0) debtor_selection.removeAllRanges();
      debtor_selection.addRange(debtor_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      debtor_selection.removeAllRanges();
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  mounted() {
    this.goodsMoney = this.$route.query.goodsMoney; //现价
    this.goodsOriginalMoney = this.$route.query.goodsOriginalMoney; //划线价
    this.couponAmount =
      this.$route.query.couponAmount.indexOf("null") > -1
        ? 0
        : this.$route.query.couponAmount; //优惠卷金额
    this.mobile = this.$route.query.mobile; //手机号
    this.shareCode = this.$route.query.shareCode; //分享码
    this.shortName = this.$route.query.shortName; //平台ID
    this.goodsId = this.$route.query.goodsId; //商品ID
    this.memberId = this.$route.query.member_id; //会员ID
    this.tpwd = this.$route.query.tpwd; //淘口令
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.thirdMall {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  height: 100%;
  box-sizing: border-box;
  .main {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    flex: 1;
    padding: 12px 20px 34px;
    .goodsImg {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .goodsTitle {
      font-size: 16px;
      color: #333333;
      line-height: 26px;
      font-weight: 500;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 12px;
      span {
        padding: 2px 5px;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        background: #ff5700;
      }
    }
    .goodsMsg {
      display: flex;
      margin-top: 12px;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      .goodsMoney {
        strong {
          font-size: 30px;
          color: #ff2020;
          letter-spacing: 0;
          font-weight: 600;
          i {
            font-size: 16px;
            color: #ff2020;
            letter-spacing: 0;
            font-weight: 500;
            font-style: normal;
          }
        }
        s {
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
          margin-left: 8px;
        }
      }
      .coupon {
        strong {
          font-size: 24px;
          color: #ff2020;
          letter-spacing: 0;
          font-weight: 500;
        }
        span {
          font-size: 18px;
          color: #ff2020;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
    }
    .copyBtn {
      height: 45px;
      background-image: linear-gradient(87deg, #ff8e00 0%, #ff5500 100%);
      border-radius: 25px;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 500;
      width: 100%;
      border: none;
      outline: none;
      margin-top: 36px;
    }
    .copyExplain {
      font-size: 14px;
      color: #ff5700;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      margin-top: 8px;
    }
    .downloadBtn {
      height: 50px;
      background: #fff0e8;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 24px;
      strong {
        font-size: 16px;
        color: #ff5700;
        letter-spacing: 0;
        font-weight: 500;
      }
      p {
        font-size: 12px;
        color: #ff8140;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
  }
}
</style>
<style lang="less">
.thirdMall {
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: solid 1px #f5f6f7;
  }
}
</style>